<br>
<div>
  <span class="headerText">Equipment</span>
  <div style="float:right">
    <div>
      <div class="headerToggleDiv">
        <label for="showInactive">Show Equipment Out of Service</label>
        <p-checkbox binary="true" name="showInactive" [(ngModel)]="getInactives"
          (ngModelChange)="getEquipment()"></p-checkbox>
      </div>
      <p-button type="button" class="addNewButton" (click)="addNew();">Add New</p-button>
    </div>
  </div>
</div>
<br />
<p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="equipment" [paginator]="true"
  [rows]="30">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [style.width]="col.width">
        {{col.header}}
        @if (col.header != '') {
        <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        }
      </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-equipment let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{equipment.number}}</td>
      <td><span class="p-column-title">{{columns[1].header}}</span>{{equipment.name}}</td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{equipment.equipmentType.type}}</td>
      <!--<td><span class="p-column-title">{{columns[3].header}}</span>{{equipment.baseFee | currency: 'USD' : symbol}}</td>-->
      <td><span class="p-column-title">{{columns[4].header}}</span>{{specificationService.EquipmentInService(equipment)
        ? 'In Service' : 'Out of Service'}}</td>
      <td>
        <p-button type="button" icon="pi pi-pencil" (click)="editEquipment(equipment)" severity="info">
        </p-button>
        <p-button type="button" icon="pi pi-trash" (click)="deleteEquipment(equipment)" severity="danger">
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>